package com.checkin.host.ui.layout

import androidx.compose.runtime.*
import kotlinx.browser.document
import kotlinx.browser.window
import org.w3c.dom.events.Event

/** Sidebar drawer jusqu'à cette largeur (évite layout « zoomé » tablette / fenêtre étroite). */
const val MOBILE_LAYOUT_BREAKPOINT = 1024

@Composable
fun rememberIsMobile(): Boolean {
    var width by remember { mutableStateOf(readViewportWidthPx()) }
    DisposableEffect(Unit) {
        val listener: (Event) -> Unit = {
            width = readViewportWidthPx()
        }
        window.addEventListener("resize", listener)
        addVisualViewportListener(listener)
        onDispose {
            window.removeEventListener("resize", listener)
            removeVisualViewportListener(listener)
        }
    }
    return width <= MOBILE_LAYOUT_BREAKPOINT
}

/** Remet le scroll et évite un zoom résiduel après login (surtout iOS Safari). */
fun resetViewportAfterNavigation() {
    window.scroll(0.0, 0.0)
    document.documentElement?.scrollLeft = 0.0
    document.body?.scrollLeft = 0.0
    document.body?.asDynamic()?.style?.zoom = ""
}

private fun readViewportWidthPx(): Int {
    val visual = js("window.visualViewport && window.visualViewport.width > 0 ? window.visualViewport.width : window.innerWidth") as Double
    return visual.toInt()
}

private fun addVisualViewportListener(listener: (Event) -> Unit) {
    val vp = window.asDynamic().visualViewport
    if (vp != null && vp != undefined) {
        vp.addEventListener("resize", listener)
    }
}

private fun removeVisualViewportListener(listener: (Event) -> Unit) {
    val vp = window.asDynamic().visualViewport
    if (vp != null && vp != undefined) {
        vp.removeEventListener("resize", listener)
    }
}
